module.exports = __webpack_public_path__ + "static/calle06-c5bc0d1d31922ebefaf5c888237f373f.png";